<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="16" height="16" rx="8" fill="#FFE7E7" />
        <path
            d="M4 8.5L6.5 11L12 5"
            stroke="#ED1C24"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: "CheckMark",
};
</script>
